export default {"src":"/_next/static/media/heartInMarker_64.7b686626.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};